import { render, staticRenderFns } from "./OtherDeliveryTabLinks.vue?vue&type=template&id=94f1e1dc"
import script from "./OtherDeliveryTabLinks.vue?vue&type=script&lang=js"
export * from "./OtherDeliveryTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports